import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./Blog.scss";
import PageBanner from "../layouts/PageBanner";
import aboutHero from "../../assets/about-hero.jpg";

const API = "https://api.ainfotech.com.np";

function BlogCard({ post }) {
  const img = post.cover_image ? `${API}${post.cover_image}` : post.image;
  const date = post.published_at ? new Date(post.published_at).toLocaleDateString() : post.date;

  return (
    <article className="avena-blogCard">
      <div className="avena-blogCard__media">
        <Link to={`/blog/${post.slug}`} className="stretched-link">
          {img ? <img src={img} alt={post.title} /> : <div className="thumb-empty">No image</div>}
        </Link>
        <div className="avena-blogCard__tags">
          {post.tag_primary && <span className="avena-tag">{post.tag_primary}</span>}
          {post.tag_secondary && <span className="avena-tag">{post.tag_secondary}</span>}
        </div>
      </div>

      <div className="avena-blogCard__body">
        <div className="avena-blogCard__meta">
          <span className="dot-sep">{date}</span>
        </div>
        <h3 className="avena-blogCard__title">
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h3>
        <p className="avena-blogCard__excerpt">{post.excerpt}</p>
        <div className="avena-blogCard__underline" />
      </div>
    </article>
  );
}

export default function Blog() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 12; // backend page size
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await fetch(`${API}/api/blog?status=published&page=${page}&limit=${limit}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Failed to load");
      setItems(data.items || []);
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page]);

  // ✅ Only show pagination if there are 10 or more posts
  const showPagination = items.length >= 10;

  return (
    <div className="avena-blog">
      <PageBanner
        title="Blog"
        bg={aboutHero}
        crumbs={[{ label: "Home", href: "/" }, { label: "Blog" }]}
      />

      <section className="container py-5">
        {err && <div className="alert alert-danger">{err}</div>}
        {loading && <div className="text-muted mb-3">Loading…</div>}

        <div className="row g-5">
          {items.map((p) => (
            <div key={p.id} className="col-12 col-lg-6">
              <BlogCard post={p} />
            </div>
          ))}
        </div>

        {/* ✅ Pagination appears only when there are 10 or more posts */}
        {showPagination && (
          <div className="d-flex justify-content-center gap-2 mt-4">
            <button
              className="btn btn-outline-secondary"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              Prev
            </button>
            <span className="align-self-center">Page {page}</span>
            <button
              className="btn btn-outline-secondary"
              onClick={() => setPage((p) => p + 1)}
              disabled={items.length < limit}
            >
              Next
            </button>
          </div>
        )}
      </section>
    </div>
  );
}
